import { useT } from "@/shared/i18n/useT";
import { isMessageId } from "@/shared/i18n/messages";
import { InlineAlert } from "@/shared/ui/InlineAlert";

interface FormErrorProps {
  /** The form's `formState.errors`; only `errors.root` is shown here. */
  errors: { root?: { message?: string } };
  className?: string;
}

/** The failure of a whole form (see applyServerErrors), shown as a danger alert. */
export function FormError({ errors, className }: FormErrorProps) {
  const t = useT();
  const message = errors.root?.message;
  if (!message) return null;
  return (
    <InlineAlert tone="danger" className={className}>
      {isMessageId(message) ? t(message) : message}
    </InlineAlert>
  );
}
